import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ServiceForget from "./ServiceForget/ServiceForget";
const ForgetPwd = (props) => {
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const { Show, Toggle } = props;
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [sendD, setSendD] = useState(false);
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setSendD(false);
  };

  //loading
  const [loading, setLoading] = useState(false);

  const HandelClick = () => {
    ServiceForget.postemail(email).then(
      (res) => {
        // res.data ? setLoading(false) : setLoading(true);

        if (res.data.message === "Email n'existe pas") {
          setLoading(false);
          setMessage("Email n'existe pas");
          setSeverity("error");
          setOpen(true);
          props.Toggle();
        } else if (res.data.message === "Veuillez vérifier votre email") {
          setLoading(false);
          setMessage("Veuillez vérifier votre email");
          setSeverity("success");
          setOpen(true);
          props.Toggle();
        }
      },
      (error) => {
        // const resMessage =
        //   (error.res && error.res.data && error.res.data.message) ||
        //   error.message ||
        //   error.toString();
        // console.log(error.message);

        setLoading(false);
        setMessage("Une erreur est produite lors de la renitialisation");
        setSeverity("error");
        setOpen(true);
        props.Toggle();
        // setLoading(false);
        // setMessage("Email n'existe pas, essayez avec un nouveau email");
        // setSeverity("error");
        // setOpen(true);
      }
    );
  };

  // console.log("toggel", props.Toggle);
  return (
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <Modal show={Show} onHide={Toggle}>
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            alt="close"
            onClick={props.Toggle}
          />
          <h6
            style={{
              marginTop: "27px",
              marginBottom: "18px",
              textAlign: "center",
            }}
          >
            Retrouvez votre compte
          </h6>

          <div className="input-field" style={{ margin: "auto" }}>
            <input
              type="email"
              placeholder="Adresse Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn2 home"
            onClick={() => {
              setLoading(true);
              setSendD(true);
              HandelClick();
            }}
            disabled={sendD}
            style={{ margin: "0 auto", width: "200px" }}
          >
            Envoyer
          </button>
        </Modal.Footer>
        {loading ? (
          <div
            className="load"
            style={{ display: "inline-flex", margin: "0 auto 15px" }}
          >
            <Alert className="mr-2 w-30" severity="info">
              Attendez svp !
            </Alert>
            <Spinner animation="border" />
          </div>
        ) : (
          ""
        )}
      </Modal>
    </>
  );
};

export default ForgetPwd;
